module.exports = __webpack_public_path__ + "static/fonts/Outfit-Medium.6febd007.ttf";